import type { ToggleOption } from "@replo/design-system/components/toggle/ToggleGroup";
import type { EditorCanvas } from "replo-utils/lib/misc/canvas";

import React from "react";

import { CANVAS_DATA } from "@/features/canvas/canvas-constants";
import { useViewportStore } from "@/features/react-editor/store/viewportStore";
import { ToggleGroup } from "@replo/design-system/components/toggle/ToggleGroup";
import { LaptopMinimal, Smartphone, Tablet } from "lucide-react";

const VIEWPORT_OPTIONS: ToggleOption[] = [
  {
    value: "mobile",
    label: <Smartphone size={18} />,
    tooltipContent: `Mobile (${CANVAS_DATA.mobile.defaultFrameWidth}px)`,
  },
  {
    value: "tablet",
    label: <Tablet size={18} className="transform -rotate-90" />,
    tooltipContent: `Tablet (${CANVAS_DATA.tablet.defaultFrameWidth}px)`,
  },
  {
    value: "desktop",
    label: <LaptopMinimal size={18} />,
    tooltipContent: `Desktop (${CANVAS_DATA.desktop.defaultFrameWidth}px)`,
  },
];

function ResponsiveControls() {
  const { currentViewport, setCurrentViewport } = useViewportStore();

  const handleViewportChange = (viewport: string) => {
    setCurrentViewport(viewport as EditorCanvas);
  };

  return (
    <div className="flex items-center gap-2">
      <ToggleGroup
        size="base"
        options={VIEWPORT_OPTIONS}
        selectedValue={currentViewport}
        onChange={handleViewportChange}
        layoutClassName="w-fit"
      />
    </div>
  );
}

export default ResponsiveControls;
